/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  allowInput: Boolean,
  autoWidth: Boolean,
  autofocus: Boolean,
  borderless: Boolean,
  clearable: Boolean,
  collapsedItems: {
    type: Function
  },
  disabled: Boolean,
  inputProps: {
    type: Object
  },
  inputValue: {
    type: [String, Number],
    "default": void 0
  },
  defaultInputValue: {
    type: [String, Number]
  },
  keys: {
    type: Object
  },
  label: {
    type: [String, Function]
  },
  loading: Boolean,
  minCollapsedNum: {
    type: Number,
    "default": 0
  },
  multiple: Boolean,
  panel: {
    type: [String, Function]
  },
  placeholder: {
    type: String,
    "default": ""
  },
  popupProps: {
    type: Object
  },
  popupVisible: {
    type: Boolean,
    "default": void 0
  },
  defaultPopupVisible: Boolean,
  readonly: Boolean,
  status: {
    type: String,
    "default": "default",
    validator: function validator(val) {
      if (!val) return true;
      return ["default", "success", "warning", "error"].includes(val);
    }
  },
  suffix: {
    type: [String, Function]
  },
  suffixIcon: {
    type: Function
  },
  tag: {
    type: [String, Function]
  },
  tagInputProps: {
    type: Object
  },
  tagProps: {
    type: Object
  },
  tips: {
    type: [String, Function]
  },
  value: {
    type: [String, Number, Boolean, Object, Array, Date],
    "default": void 0
  },
  valueDisplay: {
    type: [String, Function]
  },
  onBlur: Function,
  onClear: Function,
  onEnter: Function,
  onFocus: Function,
  onInputChange: Function,
  onMouseenter: Function,
  onMouseleave: Function,
  onPaste: Function,
  onPopupVisibleChange: Function,
  onTagChange: Function
};

export { props as default };
//# sourceMappingURL=props.mjs.map
